import { ReactElement } from 'react';
import { SplitPageLayout } from '../../components/SplitPageLayout';
import { Button } from '../../components/Button';
import { Paragraph } from '../../components/Paragraph';
import { ClockDashedIcon } from '@navikt/aksel-icons';
import classes from './ExpiredTrialPage.module.css';

export const ExpiredTrialPage = (): ReactElement => {
  const handleContactClick = () => {
    window.location.href = 'https://trustpulse.no/kontakt';
  };

  return (
    <SplitPageLayout
      backgroundImagePath="/trustpulse.svg"
      left={
        <div className={classes.container}>
          <div className={classes.iconContainer}>
            <ClockDashedIcon
              className={classes.icon}
              aria-hidden="true"
              fontSize="48px"
            />
          </div>

          <div className={classes.content}>
            <h1 className={classes.title}>Din prøveperiode er utløpt</h1>

            <Paragraph size="md" className={classes.description}>
              Vi håper du har hatt en god opplevelse med Trustpulse! For å
              fortsette å bruke tjenesten, ta kontakt med oss så hjelper vi deg
              med å sette opp et abonnement som passer for din organisasjon.
            </Paragraph>

            <div className={classes.actions}>
              <Button
                type="button"
                variant="primary"
                size="medium"
                onClick={handleContactClick}
              >
                Ta kontakt med oss
              </Button>
            </div>

            <Paragraph size="sm" className={classes.supportText}>
              Har du spørsmål? Send en e-post til{' '}
              <a href="mailto:hei@trustpulse.no" className={classes.link}>
                hei@trustpulse.no
              </a>
            </Paragraph>
          </div>
        </div>
      }
    />
  );
};
